const configUrl = {
  BASE_API_URL: 'https://api.bingotalk.cn/', // 模块一接口地址
  BASE_ADMIN_URL: 'https://admin.bingotalk.cn/', // 模块一接口地址
  BASE_CLASSPRO_URL: 'https://binguoketang.com/#/edit/course',
  VUE_APP_PARENT: 'https://binguoketang.com'
}
export default configUrl
